<div class="empty-table-container" [ngSwitch]="type">
  <ng-container *ngSwitchCase="types.InquiryDetailsMessages">
    <p>No messages available</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.InquiryDetailsNotes">
    <p>No notes available</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.InquiryDetailsPayments">
    <p>No invoices available</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.InquiryDetailsFlights">
    <p>No flights available</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.AdditionalGuests">
    <img class="empty-image" src="assets/images/empty_images/guests.svg" />

    <h5 class="empty-header">Additional Guests</h5>

    <p>
      Assign additional guests to an inquiry. You can assign existing guests by using select box and clicking Add, or
      create a new guest using Create New.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.RuleConditions">
    <i class="far fa-bolt empty-icon"></i>

    <h5 class="empty-header">Rule Conditions</h5>

    <p>
      This is a list of conditions which are required for your rule to run. Conditions determine if your rule executes
      when a certain event occurs. All conditions listed must be true for the rule to execute.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.Automations">
    <img class="empty-image" src="assets/images/empty_images/automations.svg" />

    <h5 class="empty-header">Automate your guest and user messaging.</h5>

    <p>
      You can setup automatic messaging to Tokeet users or your guests when specific events occur. Tokeet allows you to
      automate your rental management and save time. An automation is an instruction to Tokeet to perform a particular
      action when an event occurs. For example, automations may be used to notify you via email when a new booking is
      received, send a contract to a guest once their invoice is paid, send reminders to your guests or staff, or
      solicit feedback and reviews.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.DataFeed">
    <img class="empty-image" src="assets/images/empty_images/feed.svg" />

    <h5 class="empty-header">Securely extract data from Tokeet.</h5>

    <p>
      Extract data from Tokeet using a single URL and without any programming. Data feeds allow you to download your
      Tokeet data easily and securely with SSL encryption. Create a new data feed and share the URL with anyone you
      like. Delete or pause the data feed and the URL stops working. Data feeds keep you in full control of your data.
      You may customize your data feed on the fly using query parameters. See our help center for more details.
    </p>

    <p>If you need more help simply click on the help circle in the lower right of the screen.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.UpcomingArrivals">
    <img class="empty-image" src="assets/images/empty_images/arrival.svg" />

    <h5 class="empty-header">No Upcoming Arrivals</h5>

    <p>This section will show the 20 most recent arrivals within the next 30 days.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.UpcomingDepartures">
    <img class="empty-image" src="assets/images/empty_images/departure.svg" />

    <h5 class="empty-header">No Upcoming Departures</h5>

    <p>This section will show the departures within the next 30 days for in-progress bookings.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.PastDueInvoices">
    <img class="empty-image" src="assets/images/empty_images/past_due.svg" />
    <h5 class="empty-header">Past Due Invoices</h5>

    <p>This section will show the 20 most recent past due invoices within the past 60 days.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.InvoiceRuleActivityLog">
    <img class="empty-image" src="assets/images/empty_images/activity_feed.svg" />

    <h5 class="empty-header">Activity Logs</h5>

    <p>No activity logged. Your invoice activity will display in this table.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.PaymentGateways">
    <img class="empty-image" src="assets/images/empty_images/gateways.svg" />

    <h5 class="empty-header">Payment Gateways</h5>

    <p>
      Tokeet allows you to easily accept credit card payments from your guests by connecting multiple payment gateways.
      You may even connect multiple accounts from the same gateway. If you do not have a payment gateway don't worry,
      signing up only takes a few minutes. Simply click the green Add Gateway button at the top right. Once you've
      connected one of the payment gateways Tokeet will display a payment button on all your invoices so guests can pay
      quickly and easily.
    </p>

    <p>If you need more help simply click on the red help circle in the lower right of the screen.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.PaymentGatewayLog">
    <img class="empty-image" src="assets/images/empty_images/activity_feed.svg" />

    <h5 class="empty-header">Activity Logs</h5>

    <p>
      No activity logged. Your payment activity will display in this table once you start collecting payments via this
      gateway.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.PaymentRules">
    <img class="empty-image" src="assets/images/empty_images/payment_rule.svg" />

    <h5 class="empty-header">Payment Rules</h5>

    <p>
      You may create rules for how your payments are processed. Specify which gateway to use for which channel or rental
      and turn on auto billing for some channels. Rules override your default gateway setting and affect which gateway
      is used to process your invoice payments.
    </p>

    <p>
      <a target="_blank" href="https://help.tokeet.com/invoices-and-billing/payment-gateways/payment-rules"
        >Click here</a
      >
      to see how it works. If you need more help simply click on the red help circle in the lower right of the screen.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.UserSettings">
    <img class="empty-image" src="assets/images/empty_images/add_user.svg" />

    <h5 class="empty-header">Add More Users</h5>

    <p>You may add users to your account by clicking the ADD button at the top right above the table.</p>

    <p>If you need more help simply click on the help circle in the lower right of the screen.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.Templates">
    <img class="empty-image" src="assets/images/empty_images/templates.svg" />

    <h5 class="empty-header">Create your Template.</h5>

    <p>You can create different types of templates to send to your guests via email or Push Notification.</p>

    <p>Create a template now by clicking the ADD button above.</p>

    <p>If you need more help simply click on the red help circle in the lower right of the screen.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.AutomataTriggers">
    <img class="empty-image" src="assets/images/empty_images/automations.svg" />

    <h5 class="empty-header">Triggers</h5>

    <p>
      Triggers allow you to automate your rental management and save time. A trigger performs a specific action when an
      event occurs. For example, triggers may be used to notify your cleaners when a new booking is received or to
      automatically reply to guests. Replying quickly to guests will increase your search rankings and chances of
      getting more bookings.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.Invoices">
    <img class="empty-image" src="assets/images/empty_images/invoices.svg" />

    <h5 class="empty-header">You haven't created any invoices.</h5>

    <p>
      To create an invoice simply go to any Inquiry Detail and click the Create Invoice button. This will create a new
      invoice which you can send to your guest for payment. The invoice will be automatically populated with all the
      needed information. It's quick and easy, give it a try.
    </p>

    <p>
      <a target="_blank" href="https://help.tokeet.com/invoices-and-billing/invoice-management/invoicing-payments"
        >Click here</a
      >
      for a short video on how it works. If you need more help simply click on the help circle in the lower right of the
      screen.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.ChannelConnections">
    <img class="empty-image" src="assets/images/empty_images/connections.svg" />

    <h5 class="empty-header">You haven't connected to any channels.</h5>

    <p>To connect to a channel simply click the Add Channel button.</p>

    <p>
      <a target="_blank" href="https://help.tokeet.com/channel-manager/tokeet-channel-manager-overview"
        ><span class="fas fa-video"></span> Click here</a
      >
      for a short video on how it works. If you need more help simply click on the red help circle in the lower right of
      the screen.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.InquiriesList">
    <img class="empty-image" src="assets/images/empty_images/search.svg" />

    <h5 class="empty-header">Your inquiries inbox.</h5>

    <p>
      This is your inquiries list where you may view all your reservation inquiries. You can manually enter a new
      inquiry using the ADD button above or have inquiries generated from your marketing channels. In order for
      inquiries from your marketing channels (Flipkey, VRBO, etc) to show in Tokeet you must enter your Tokeet rental
      email address into your marketing channel's contact section. You will find your Tokeet rental email address in the
      Rental Settings of each rental. Also, you can use an inquiry widget to capture inquiries on your website.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.InquiriesInbox">
    <img class="empty-image" src="assets/images/empty_images/search.svg" />

    <h5 class="empty-header">Your inquiries inbox.</h5>

    <p>
      This is your inquiries inbox where you may view all your reservation inquiries. You can manually enter a new
      inquiry using the round green plus button at the top left or have inquiries generated from your marketing
      channels. In order for inquiries from your marketing channels (Flipkey, VRBO, etc) to show in Tokeet you must
      enter your Tokeet rental email address into your marketing channel's contact section. You will find your Tokeet
      rental email address in the Rental Settings of each rental. Also, you can use an inquiry widget to capture
      inquiries on your website.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.InquiriesInboxList">
    <img class="empty-image" src="assets/images/empty_images/search.svg" />

    <h5 class="empty-header">No inquiries match your search</h5>

    <p>
      We couldn't find what you're looking for, <br />
      please modify your search criteria to view inquiries.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.RentalsList">
    <img class="empty-image" src="assets/images/empty_images/rentals.svg" />

    <h5 class="empty-header">Add your rentals.</h5>

    <p>
      Rental settings are an essential and required component of your Tokeet account. Once you've added a Rental you can
      then specify your rental rates, currency, and other rental details. It's time to add your first rental in Tokeet.
      You may add rentals by clicking the ADD button above, or by importing them from your channels. Go to the Channels
      section to import your rentals.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.GuestsList">
    <img class="empty-image" src="assets/images/empty_images/guests.svg" />

    <h5 class="empty-header">Grow your guestbook</h5>
    <p>
      This is your guest list where you can view all your guest contacts. You may enter guests manually by clicking the
      ADD button above. Guests will also be automatically added to your guest list whenever they send an inquiry to your
      Tokeet email address or inquire online via your inquiry widget. We recommend uploading guests via csv or vcard
      files, so you don't have to enter anything manually.
    </p>
    <br />
    <p class="text-left" style="line-height: 24px">
      <span class="text-left"
        ><a target="_blank" href="https://help.tokeet.com/handling-inquiries/guest-list-overview" style="color: #00bcd3"
          ><i class="fal fa-video-camera"></i> Click here</a
        >
        for a short video on how it works. </span
      >If you need more help simply click on the red help circle in the lower right of the screen.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.GuestNotesList">
    <img class="empty-image" src="assets/images/empty_images/file-signature.svg" />

    <h5 class="empty-header">No Guest Notes</h5>
    <p>There are no notes about this guest. Keep notes about your guests so you don't forget the important things.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.GuestInteractionsList">
    <img class="empty-image" src="assets/images/empty_images/comments.svg" />

    <h5 class="empty-header">No Guest Interactions</h5>
    <p>
      You haven't recorded any interactions with this guest. Use Tokeet as your complete CRM and record all important
      guest interactions for future reference.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.GuestFilesList">
    <img class="empty-image" src="assets/images/empty_images/file-alt.svg" />

    <h5 class="empty-header">No Guest Files</h5>
    <p>You haven't saved any files related to this guest. You should upload important guest documents here.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.InvoiceRules">
    <img class="empty-image" src="assets/images/empty_images/invoice_rules.svg" />

    <h5 class="empty-header">Invoice Rules</h5>

    <p>
      Invoice rules allow you to automate your invoice management and save time. Invoice rule performs a specific action
      when an event occurs.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.InvoiceAssociatedRules">
    <img class="empty-image" src="assets/images/empty_images/invoice_rules.svg" />

    <h5 class="empty-header">Invoice Rules</h5>

    <p>
      Invoice rules allow you to automate your invoice management and save time. Invoice rule performs a specific action
      when an event occurs.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.InvoiceTemplates">
    <img class="empty-image" src="assets/images/empty_images/expenses.svg" />

    <h5 class="empty-header">Invoice Templates</h5>

    <p>
      Templates contain the content which will be used in your automatic invoices. For example, templates contain the
      body of the email message which your rules will send. Create a template by clicking the 'Create Booking Template'
      button above.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.GuestEmailsList">
    <img class="empty-image" src="assets/images/empty_images/envelope-open.svg" />

    <h5 class="empty-header">No Guest Messages</h5>
    <p>
      You haven't messaged this guest or received a message from them. Keep the communication going to ensure guest
      satisfaction.
    </p>

    <ng-content></ng-content>
  </ng-container>

  <ng-container *ngSwitchCase="types.GuestBookingsList">
    <img class="empty-image" src="assets/images/empty_images/search.svg" />

    <h5 class="empty-header">No bookings available</h5>

    <p>
      You haven't created any bookings yet, but we know you will soon. To create a booking click the Add button on the
      top right part of the overlay. This will mark the Inquiry as booked and display it in your calendar. It will also
      update all of your channel's calendars, if you've uploaded your calendar URL in those channels. For more help
      click the help circle in the lower right of the screen.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.GuestOtherBookingsList">
    <p>No other bookings</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.FileCabinet">
    <img class="empty-image" src="assets/images/empty_images/cabinet.svg" />

    <h5 class="empty-header">Smarter file storage.</h5>

    <p>
      The Tokeet File Cabinet is a smarter way to attach files to your messages. Whenever you attach a file to a message
      sent to any guest Tokeet saves that file to your File Cabinet. The file can then be attached to subsequent
      messages to any guest without needing to re-upload the attachment. Even better, the file can be used by any other
      user in your Tokeet account. Click the Upload button above to upload a new file to your File Cabinet.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.BillingHistory">
    <p>No billing activity recorded</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.AIChargeHistory">
    <p>No charge activity recorded</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.Agenda">
    <i class="fal fa-list-alt empty-icon"></i>

    <h5 class="empty-header">Need Some Help?</h5>

    <p>
      Once you create bookings they will show on all your calendar views. The agenda view allows you to see your events
      and know what to do. It's perfect for staff on the ground who need to know what's happening next. If you need more
      help simply click the help circle on the lower right of the screen.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.Hold">
    <img class="empty-image" src="assets/images/empty_images/calendar-minus.svg" />

    <h5 class="empty-header">Looking for your hold events?</h5>

    <p>All hold events will show up here. You can manually create a new hold event on your calendars.</p>

    <p>If you need more help simply click on the help circle in the lower right of the screen.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.Expenses">
    <img class="empty-image" src="assets/images/empty_images/expenses.svg" />

    <h5 class="empty-header">Looking for your expenses?</h5>

    <p>
      All expenses will show up here. You can manually add a new expense by clicking the ADD button above. You can also
      export your expenses to a CSV file or upload a CSV file to save time on manual entry.
    </p>

    <p>If you need more help simply click on the help circle in the lower right of the screen.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.Tasks">
    <img class="empty-image" src="assets/images/empty_images/tasks.svg" />

    <h5 class="empty-header">Add More Tasks</h5>

    <ng-container *ngxPermissionsOnly="['canAddTasks']">
      <p>You may add tasks to your account by clicking the ADD button at the top right above the table.</p>

      <p>If you need more help simply click on the help circle in the lower right of the screen.</p>
    </ng-container>

    <ng-container *ngxPermissionsExcept="['canAddTasks']">
      <p>
        Any tasks assigned to you will be presented here. You can open a task by clicking on it and mark it as completed
        once you have done so.
      </p>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="types.EmailOptions">
    <img class="empty-image" src="assets/images/empty_images/email_connections.svg" />

    <h5 class="empty-header">No Email Forwarding</h5>

    <p>Please Add your email forwardings to see your them here</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.SlackChannelConfig">
    <i class="fal fa-plug empty-icon"></i>

    <h5 class="empty-header">Connect your slack channels.</h5>

    <p>
      This is a list of your connected Slack channels. Use the Connect button to assign a Tokeet event to a specific
      channel in your slack account. Once a connection is made, Tokeet will send a message to the specified channel
      whenever that event occurs.
    </p>

    <p>If you need more help simply click on the help circle in the lower right of the screen.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.SharedContent">
    <img class="empty-image" src="assets/images/empty_images/share.svg" />

    <h5 class="empty-header">Shared Content.</h5>

    <p>
      This is your shared content list where you can view all shares that were previously created. You may share content
      by clicking the SHARE button above, or disable and delete existing shared content.
    </p>

    <p>If you need more help simply click on the red help circle in the lower right of the screen.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.CustomCodesList">
    <i class="fal fa-book empty-icon"></i>

    <h5 class="empty-header">Custom Codes</h5>

    <p>
      Custom codes allow you to create custom information fields that can be inserted into templates. Each custom code
      can be related to a specific rental or a group of rentals. When the same custom code is used for multiple rentals
      Tokeet will automatically pull the respective custom code for the rental.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.RentalRates">
    <img class="empty-image" src="assets/images/empty_images/rates.svg" />

    <h5 class="empty-header">No Rates Created</h5>

    <p>
      You haven't created any rates yet. Click on the green button above to create a rate of your choice. Need more
      advanced rate management? Try <a href="https://www.rategenie.io" target="_blank">Rategenie</a> today. Rategenie is
      Tokeet's best-in-class dynamic pricing tool.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.GroupRates">
    <img class="empty-image" src="assets/images/empty_images/rates.svg" />
    <h5 class="empty-header">Group Rates</h5>

    <p>No group rates available.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.ChannelAdjustments">
    <img class="empty-image" src="assets/images/empty_images/box-up.svg" />

    <h5 class="empty-header">Channel Adjustments</h5>

    <p>No channel adjustments available.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.RentalRateMappings">
    <img class="empty-image" src="assets/images/empty_images/compress-alt.svg" />

    <h5 class="empty-header">Rate Mappings</h5>

    <p>
      No rate mapping set. <br />
      Rate mappings allow you to specify which Tokeet rates should be pushed to specific channel rates. This setting is
      required for automatic rate pushes and allows you to update all linked channels with one click.
      <br /><br />
      Need advanced rate management? Try Rategenie, Tokeet's best-in-class dynamic pricing application.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.MessageFeed">
    <img class="empty-image" src="assets/images/empty_images/envelope-open.svg" />

    <h5 class="empty-header">Message Feed</h5>

    <p>No messages available</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.MonthlyOccupancyRateChart">
    <i class="fal fa-chart-line empty-icon"></i>

    <p>
      Your monthly occupancy rate will appear here once we have imported bookings to your Tokeet account. The bar graph,
      which can be filtered by rental and/or year will show each month and the occupancy rate for each.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.BookingMtdChart">
    <i class="fal fa-chart-line empty-icon"></i>

    <p>
      Your number of bookings per month will show here once we have imported bookings to your Tokeet account. The graph
      can be filtered by rental and/or year.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.RevenueMtdChart">
    <i class="fal fa-chart-line empty-icon"></i>

    <p>
      Your monthly revenue will show here in the form of a bar graph once we have imported bookings to your Tokeet
      account. The graph can be filtered by rental and/or year.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.ActivityFeed">
    <img class="empty-image" src="assets/images/empty_images/activity_feed.svg" />

    <p>
      Your important account activity will show here. This will allow you to easily stay on top of new bookings,
      cancellations, and invoice payments.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.Websites">
    <img class="empty-image" src="assets/images/empty_images/window.svg" />

    <h5 class="empty-header">Create a website in 5 minutes.</h5>

    <p>
      It's time to create your rental website with Tokeet. You can create a website by clicking the Create button above.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.WebsitePages">
    <img class="empty-image" src="assets/images/empty_images/file-invoice.svg" />

    <h5 class="empty-header">Add an additional webpage.</h5>

    <p>
      You may add additional pages to your website simply by creating a new page here. Your additional pages will be
      linked from the homepage of your website.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.WebsiteRentals">
    <img class="empty-image" src="assets/images/empty_images/file-invoice.svg" />

    <h5 class="empty-header">Website rentals.</h5>

    <p>
      You may select which rentals you would like to include in this website. However, you must first create some
      rentals in the Rentals section.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.Stealths">
    <img class="empty-image" src="assets/images/empty_images/stealth.svg" />

    <h5 class="empty-header">Stealth Automation.</h5>

    <p>
      Stealth mode unlists your Airbnb rental during specific hours of the day and hides it from prying eyes. It will be
      re-listed at a time you specify and when you are more likely to be seen by potential guests.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.AutomationLogs">
    <img class="empty-image" src="assets/images/empty_images/bell.svg" />

    <h5 class="empty-header">Automation Logs</h5>

    <p>No activity logged. This trigger has not been fired recently.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.LosDiscounts">
    <img class="empty-image" src="assets/images/empty_images/los-discount.svg" />

    <h5 class="empty-header">No LOS discounts yet</h5>

    <p>You have not created any discounts, please click <b>Add</b> button to add new discount</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.DiscountCodes">
    <img class="empty-image" src="assets/images/empty_images/discount-codes.svg" />

    <h5 class="empty-header">No Discount codes yet</h5>

    <p>You have not created any discounts, please click <b>Add</b> button to add new discount</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.RentalDiscounts">
    <img class="empty-image" src="assets/images/empty_images/discounts.svg" />

    <h5 class="empty-header">No Discount yet</h5>

    <p>You have not created any discounts, please click <b>Add</b> button to add new discount</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.DiscountCodeActivities">
    <img class="empty-image" src="assets/images/empty_images/discount-codes.svg" />

    <h5 class="empty-header">No Discount activities yet</h5>

    <p>No activity logged. This discount has not been applied.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.DiscountCodeLogs">
    <img class="empty-image" src="assets/images/empty_images/discount-codes.svg" />

    <h5 class="empty-header">No Discount logs yet</h5>

    <p>No logs yet. This discount has not been modified.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.BookingFormulas">
    <img class="empty-image" src="assets/images/empty_images/tasks.svg" />

    <h5 class="empty-header">No Booking formulas yet</h5>

    <p>You have not created any formulas, please click <b>Add</b> button to add new formula</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.PushAllRentals">
    <i class="empty-icon fal fa-share-alt"></i>

    <h5 class="empty-header">No Listings Connected</h5>

    <p>Please link at least one listing to your channel for using this feature</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.MappedRentals">
    <img class="empty-image" src="assets/images/empty_images/mapped_rentals.svg" />
    <h5 class="empty-header">No Mapped Rentals</h5>

    <p>
      No mapped rentals found. Either your accommodation id is wrong or you need to complete connection via the channel.
    </p>
  </ng-container>
  <ng-container *ngSwitchCase="types.AirbnbReviews">
    <img class="empty-image" src="assets/images/empty_images/reviews.svg" />

    <h5 class="empty-header">No Reviews</h5>

    <p>Please link your channel to see your reviews here</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.AirbnbOpportunities">
    <img class="empty-image" src="assets/images/empty_images/opportunities.svg" />
    <h5 class="empty-header">No Opportunities</h5>

    <p>Please link your channel to see your opportunities here</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.AirbnbNotifications">
    <img class="empty-image" src="assets/images/empty_images/notifications.svg" />
    <h5 class="empty-header">No Notifications</h5>

    <p>Please link your channel to see your notifications here</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.Commissions">
    <img class="empty-image" src="assets/images/empty_images/commissions.svg" />
    <h5 class="empty-header">No Commissions</h5>

    <p>You have not created any commissions, please click <b>Add</b> button to add new commission</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.Integrations">
    <img class="empty-image" src="assets/images/empty_images/search.svg" />
    <h5 class="empty-header">No Integrations match your search</h5>

    <p>
      We couldn't find what you're looking for, <br />
      please modify your search criteria to view integrations
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.rentalSearch">
    <img class="empty-image" src="assets/images/empty_images/search.svg" />
    <h5 class="empty-header">No Rentals match your search</h5>

    <p>
      We couldn't find what you're looking for, <br />
      please modify your search criteria to view rentals
    </p>
  </ng-container>
  <ng-container *ngSwitchCase="types.NoRentals">
    <img class="empty-image" src="assets/images/empty_images/rentals.svg" />
    <h5 class="empty-header">No Rentals</h5>

    <p>Add rental from the <b>Rentals</b> menu in the top.</p>
  </ng-container>

  <ng-container *ngSwitchCase="types.NoBookings">
    <img class="empty-image" src="assets/images/empty_images/calendar.svg" />
    <h5 class="empty-header">No Bookings Added</h5>

    <p>
      There is no bookings to show here, <br />
      please click <b>Edit</b> button to add bookings.
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="types.NoRates">
    <img class="empty-image" src="assets/images/empty_images/rates.svg" />
    <h5 class="empty-header">No Rates Added</h5>

    <p>
      There is no rates to show here, <br />
      please click <b>Edit</b> button to add rates.
    </p>
  </ng-container>
  <ng-container *ngSwitchCase="types.ImportedCalendars">
    <img class="empty-image" src="assets/images/empty_images/calendar.svg" />
    <h5 class="empty-header">No Imported Calendars</h5>

    <p>Please import a calendar to see your it here</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.ExportedCalendars">
    <img class="empty-image" src="assets/images/empty_images/calendar.svg" />
    <h5 class="empty-header">No Exported Calendars</h5>

    <p>Please create an exported calendar to see your it here</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.ConnectionActivities">
    <img class="empty-image" src="assets/images/empty_images/activity_feed.svg" />

    <h5 class="empty-header">Activity Logs</h5>

    <p>No activity log. You should push rates and availability to ensure your connection is working correctly.</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.Reviews">
    <i class="empty-icon far fa-comments-alt"></i>

    <h5 class="empty-header">No Reviews</h5>

    <p>Please link your channel to see your reviews here</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.AIDocuments">
    <img class="empty-image" src="assets/images/empty_images/templates.svg" />

    <h5 class="empty-header">No documents</h5>

    <p>Please upload your documents to see them here</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.AIWebsites">
    <img class="empty-image" src="assets/images/empty_images/templates.svg" />

    <h5 class="empty-header">No Websites</h5>

    <p>Please add your websites to see them here</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.AIIgnoreBookings">
    <img class="empty-image" src="assets/images/empty_images/templates.svg" />

    <h5 class="empty-header">No Ignored Bookings</h5>

    <p>Please add your bookings to exclude them from TokeetAI automated responses</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.AIIgnoreGuests">
    <img class="empty-image" src="assets/images/empty_images/templates.svg" />

    <h5 class="empty-header">No Ignored Guests</h5>

    <p>Please add your guests to exclude them from TokeetAI automated responses</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.AIIgnoreRentals">
    <img class="empty-image" src="assets/images/empty_images/templates.svg" />

    <h5 class="empty-header">No Ignored Rentals</h5>

    <p>Please add your rentals to exclude them from TokeetAI automated responses</p>
  </ng-container>
  <ng-container *ngSwitchCase="types.AIIgnoreGuestsRegexp">
    <img class="empty-image" src="assets/images/empty_images/templates.svg" />

    <h5 class="empty-header">No Ignored Regex Patterns</h5>

    <p>Please add your regex to exclude the guests from TokeetAI automated responses when emails are matched</p>
  </ng-container>
</div>
